<template>
<div class="overlay container-fluid">
    <div class="row">
        <div class="player player-left" v-bind:class="{ 'col-6': this.userdata[this.right] !== undefined, 'col-12': this.userdata[this.right] === undefined }" v-if="this.userdata[this.left] !== undefined">
            <div class="row">
                <div class="dragonball float-left" v-for="n in leftLife"></div>
            </div>
            <div class="row">
                Deck: {{ userdata[left].deck }} &bull; Hand: {{ userdata[left].hand }} &bull; Drop: {{ userdata[left].dz }} &bull; Warp: {{ userdata[left].warp }}
            </div>
        </div>
        <div class="player player-right" v-bind:class="{ 'col-6': this.userdata[this.left] !== undefined, 'col-12': this.userdata[this.left] === undefined }" v-if="this.userdata[this.right] !== undefined">
            <div class="row d-flex justify-content-end">
                <div class="dragonball" v-for="n in rightLife"></div>
            </div>
            <div class="row d-flex justify-content-end">
                Deck: {{ userdata[right].deck }} &bull; Hand: {{ userdata[right].hand }} &bull; Drop: {{ userdata[right].dz }} &bull; Warp: {{ userdata[right].warp }}
            </div>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Overlay',
    props: ['left', 'right', 'userdata'],
    computed: {
        leftLife: function() {
            if (!this.userdata[this.left].life) return 0;
            return parseInt(this.userdata[this.left].life)
        },
        rightLife: function() {
            if (!this.userdata[this.right].life) return 0;
            return parseInt(this.userdata[this.right].life)
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.dragonball {
    background-image: url('../assets/dragonball.png');
    background-repeat: no-repeat;
    background-size: contain;

    width: 50px;
    height: 50px;
}
</style>



// WEBPACK FOOTER //
// src/components/Overlay.vue